export enum ApiCollectionName {
  Client = 'client',
}

export enum UserRole {
  admin = 'admin',
  developer = 'developer'
}
